





























import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import checkout from '../../store/modules/checkout';
import Sidebar from '@/components/UI/Sidebar.vue';
import Login from '@/components/Checkout/UserStep/Login.vue';
import ForgotPassword from '@/components/Checkout/UserStep/ForgotPassword.vue';
import Registration from '@/components/Checkout/UserStep/Registration.vue';
import gtmhelpers from '@/commons/gtmhelpers';
import store from '@/store';

@Component({
  components: {
    Sidebar,
    Login,
    ForgotPassword,
    Registration,
  },
})
export default class UserStep extends Vue {

  get email(): string {
    return checkout.email;
  }

  set email(value: string) {
    checkout.setEmail(value);
  }

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get fulfilled(): boolean {
    return checkout.stepByName('userdata').fulfilled;
  }

  get confirmText() {
    return store.state.options.carrier.multicarrier ? 'Further' : 'Confirm';
  }

  private editStep() {
    checkout.stepByName('userdata').fulfilled = false;
  }

  private async save(email: string) {
    const valid = await this.$validator.validateAll();
    if (!valid) {
      return;
    }

    try {
      await checkout.assignEmail(email);
      checkout.goingToStep({fromStep: 'userdata', toStep: 'invoice'});
    } catch (e) {
      this.$toast.err(e.response.data.message);
    }
  }
}
